export enum VideoPlayerState {
 MINIMIZED = 'minimized',
 COLLAPSED = 'collapsed',
 NORMAL = 'normal',
 EXPANDED = 'expanded',
 FULLSCREEN = 'fullscreen',
}